import { Icon } from "@chakra-ui/react";
import React from "react";

/**
 * Renders the save icon
 * 
 * @param {Object} props - The props of the component
 * @returns The save icon
 */
const SaveIcon = (props) => (
  <Icon viewBox="0 0 36 35" fill="none" {...props}>
    <path d="M35.5 7.77778V31.1111C35.5 32.1806 35.1192 33.0961 34.3576 33.8576C33.5961 34.6192 32.6806 35 31.6111 35H4.38889C3.31944 35 2.40394 34.6192 1.64236 33.8576C0.880787 33.0961 0.5 32.1806 0.5 31.1111V3.88889C0.5 2.81944 0.880787 1.90394 1.64236 1.14236C2.40394 0.380787 3.31944 0 4.38889 0H27.7222L35.5 7.77778ZM31.6111 9.43056L26.0694 3.88889H4.38889V31.1111H31.6111V9.43056ZM18 29.1667C19.6204 29.1667 20.9977 28.5995 22.1319 27.4653C23.2662 26.331 23.8333 24.9537 23.8333 23.3333C23.8333 21.713 23.2662 20.3356 22.1319 19.2014C20.9977 18.0671 19.6204 17.5 18 17.5C16.3796 17.5 15.0023 18.0671 13.8681 19.2014C12.7338 20.3356 12.1667 21.713 12.1667 23.3333C12.1667 24.9537 12.7338 26.331 13.8681 27.4653C15.0023 28.5995 16.3796 29.1667 18 29.1667ZM6.33333 11.5H23.8333V5.83333H6.33333V11.5ZM4.38889 9.43056V31.1111V3.88889V9.43056Z" fill="currentColor" />
  </Icon>
);

export default React.memo(SaveIcon);
